// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"300":"6f62c7e9","396":"716074ba","558":"fb9e5d75"}[chunkId] + ".js";
};